module.exports = "/assets/20c6d6897041b60ab945b338e9f1db18.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/TS.png
// module id = 1867
// module chunks = 0